import * as React from "react";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemText from "@mui/material/ListItemText";
import Typography from "@mui/material/Typography";
import Icon1 from "../icons/Icon";
import Space from "../layout/Space";
import PrimaryButton from "../buttons/PrimaryButton";
import Row from "../layout/Row";
import sendDVemail from "../api/sign/sendDVemail";
import { useAppContext } from "../config/AppContext";
import { useSnackbar } from "notistack";
import { getOrRefreshFirebaseToken } from "../config/getFirebaseToken";
import {
  getDocDataById,
  getDocDataByRef,
  getFlutterTime,
  updateDocDataField,
} from "../models/DataFunctions";
import { deleteDoc } from "firebase/firestore";
import downloadFile from "../api/download/downloadFile";
import Modal1 from "../modals/Modal1";
import SendInvoiceToSign from "../folder_modals/SendInvoiceToSign";
import DropSignedDevis from "../folder_modals/DropSignedDevis";
import updateDocDataFieldApi from "../api/database/updateDocDataFieldApi";
import deleteDocApi from "../api/database/deleteDocApi";
import SmallSpinner from "../loading/SmallSpinner";
import CreateFolderFromDevis from "../folder_modals/CreateFolderFromDevis";
import createDocApi from "../api/database/createDocApi";
import { useState } from "react";
import { useEffect } from "react";
import { MenuItemBlock } from "../pages/folder_pages/FoldersAM";
import updateDocApi from "../api/database/updateDocApi";
import initiatePayment from "../api/folder/initiatePayment";
import moment from "moment";

export default function PaymentAM({
  orgData,
  paymentData,
  folderData,
  handleRefresh,
  navigateWorkspace,
  workspaceData,
  masterData,
  createFolderOpen,
  setCreateFolderOpen,
  setEmailOpen,
}) {
  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };

  const { appState, setAppState } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const [dropSigned, setDropSigned] = React.useState(false);
  const [loadingNewFolder, setLoadingNewFolder] = React.useState(false);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleGoFolder = async () => {
    let folder = await getDocDataByRef(paymentData.folder_ref);
    if (!folder) {
      handleClickVariant("Le dossier n'existe pas", "error");
      await updateDocDataFieldApi(paymentData.ref, "folder_ref", null, prefix);
      handleRefresh();
      return;
    } else {
      navigateWorkspace("/folder/" + paymentData.folder_ref.id);
    }
  };

  const handleDownload = async () => {
    if (!paymentData.file?.url) {
      handleClickVariant("Le fichier n'est pas disponible", "error");
      return;
    }
    await downloadFile(paymentData.file, "Devis " + paymentData.nom);
  };

  const handleCancel = async () => {
    if (paymentData.state === "error") {
      handleClickVariant("Le paiment est déjà annulé", "error");
      return;
    }
    await updateDocDataFieldApi(paymentData.ref, "state", "error", prefix);
    handleClickVariant("Paiement annulé avec succès", "success");
    handleClose();
    handleRefresh();
  };

  const handleDelete = async () => {
    if (paymentData.state === "done") {
      handleClickVariant(
        "Vous ne pouvez pas supprimer un paiment signé",
        "error"
      );
      return;
    }
    await deleteDocApi(paymentData.ref, prefix);
    handleClickVariant("Devis supprimé avec succès", "success");
    handleClose();
    navigateWorkspace("/invoices");
  };
  const [loadingData, setLoadingData] = useState(null);
  const handleSendAgain = async () => {
    if (loadingData) return;
    setLoadingData(true);
    const token = await getOrRefreshFirebaseToken(); // Fetch Firebase token
    let payment = await getDocDataById("payment", paymentData.id);
    let delay = moment().unix() - payment.initiation_seconds;
    if (delay < 3600) {
      handleClickVariant(
        "Il vous reste " +
          Math.floor((3600 - delay) / 60) +
          " minutes avant de pouvoir renvoyer la demande de paiement",
        "error"
      );
      setLoadingData(null);
      return;
    }

    let history_events = payment.history_events || [];
    console.log("history_events", history_events);

    history_events.push({
      date: getFlutterTime(),
      name: "Demande de paiement renvoyée",
    });
    await updateDocApi(
      payment.ref,
      {
        history_events: history_events,
        state: "initiated",
        initiation_seconds: moment().unix(),
      },
      prefix
    );
    await updateDocDataFieldApi(
      folderData.ref,
      "reglement.state",
      "initialised",
      prefix
    );

    await initiatePayment(payment.folder_ref.id, payment.id, token, prefix);
    handleClickVariant("Demande de paiement envoyée avec succès", "success");
    setLoadingData(null);
    handleClose();
  };

  const handleModify = () => {
    navigateWorkspace("/modifypayment/" + paymentData.id);
  };

  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(open);
  }, [open]);

  return (
    <div>
      <PrimaryButton
        id="basic-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
      >
        <Row x={10}>
          Actions <Icon1 icon_name="menu" fill="white"></Icon1>
        </Row>
      </PrimaryButton>
      {anchorEl && (
        <div>
          <div
            className=" fixed top-0 left-0  bg-transparent h-screen w-screen z-10  "
            onClick={handleClose}
          ></div>
          <div
            id="basic-menu"
            open={open}
            onClose={handleClose}
            className={`bg-white ${isVisible ? "scale-100 opacity-100" : "scale-95 opacity-0"} transition-all duration-300 min-w-c300 w-fit flex-col flex rounded-lg shadow-2xl shadow-shadow_25 l fixed z-20 py-3 px-1   ${false ? "right-10  2.8xl:right-auto" : ""}`}
          >
            <div className={` flex flex-col w-c300 `}>
              <div className="pl-4 pb-2 text-h3 font-light text-pr bg-transparent text-shadow_50">
                ACTIONS RAPIDES
              </div>

              {paymentData.master_id === orgData?.id && (
                <>
                  {paymentData.state !== "paid" && (
                    <MenuItemBlock
                      onClick={() => {
                        handleModify();
                      }}
                    >
                      <div className="">
                        <Icon1 icon_name="modify"></Icon1>
                      </div>
                      <Space x={10} />
                      <div className="flex text-h3">Modifier le paiment</div>
                    </MenuItemBlock>
                  )}

                  {paymentData.state !== "paid" && (
                    <>
                      <MenuItemBlock
                        onClick={() => {
                          handleSendAgain();
                        }}
                      >
                        <div className="">
                          {loadingData ? (
                            <SmallSpinner></SmallSpinner>
                          ) : (
                            <Icon1 icon_name="share"></Icon1>
                          )}
                        </div>
                        <Space x={10} />
                        <div className="flex text-h3">Relancer par email</div>
                      </MenuItemBlock>{" "}
                      <MenuItemBlock
                        onClick={() => {
                          handleCancel();
                          handleClose();
                        }}
                      >
                        <div className="">
                          <Icon1 icon_name="delete"></Icon1>
                        </div>
                        <Space x={10} />
                        <div className="flex text-h3">Annuler le paiement</div>
                      </MenuItemBlock>
                    </>
                  )}
                </>
              )}
              {paymentData.folder_ref && (
                <MenuItemBlock onClick={handleGoFolder}>
                  <div className="">
                    <Icon1 icon_name="folder"></Icon1>
                  </div>
                  <Space x={10} />
                  <div className="flex  text-h3">Aller au dossier</div>
                </MenuItemBlock>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
